import { render, staticRenderFns } from "./ViewedProducts.vue?vue&type=template&id=3733932a&"
import script from "./ViewedProducts.vue?vue&type=script&lang=ts&"
export * from "./ViewedProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductBlockLister: require('/home/vsts/work/1/a/NuxtApp/components/product/block/Lister.vue').default})
